import {Component, OnInit} from '@angular/core';
import {RouteService} from '../../../../core/services/route.service';
import {OrderApiService} from '../../../../core/services/order.api.service';
import {GroupOrderTab, OrderTab, TabInStorage} from '../../../../core/models/payment-item.model';
import {filter} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {CartStore} from '../../../../core/stores/cart.store';
import {STORAGE_TAB_DATA} from '../../../../core/constants';
import {PaymentStore} from '../../../../core/stores/payment.store';
import {StorageService} from '../../../../core/services/storage.service';
import {PaymentService} from '../../../../core/services/payment.service';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {
  public isLoading = true;
  public isShowTabModal: boolean;
  public tabModalInfo: any;
  private cacheTab = true;

  public tabModals = [
    {
      title: 'Tab not found',
      text: 'Please check if the ID is correct and try again',
      coloredText: '',
      buttonText: 'Back to home page'
    }
  ];


  constructor(private paymentStore: PaymentStore,
              private cartStore: CartStore,
              private route: ActivatedRoute,
              private routeService: RouteService,
              private storageService: StorageService,
              private paymentService: PaymentService,
              private router: Router,
              private orderApiService: OrderApiService) {
  }

  ngOnInit() {
    this.cacheTab = !(this.route.snapshot.queryParams.options === 'nocache');
    if (this.routeService.getGroupTabId()) {
      this.fetchGroupTab();
    } else {
      this.fetchTab();
    }
  }

  public redirectButtonClick(): void {
    if (this.cartStore.tab) {
      this.tabModalInfo === this.tabModals[0] ? this.backToLocation(this.cartStore.tab) : this.backToHomePage();
    } else {
      this.tabModalInfo === this.tabModals[0] ? this.backToGroup(this.cartStore.groupTab) : this.backToHomePage();
    }
  }

  private fetchTab(): void {
    this.orderApiService.getTabById(this.routeService.getTabId())
      .pipe(filter(Boolean))
      .subscribe((tab: OrderTab) => {
        this.cartStore.tab = tab;
        if (this.cacheTab) {
          this.storageService.set(STORAGE_TAB_DATA, new TabInStorage(this.cartStore.tab.tab_id, this.cartStore.tab.location_id, false));
        }
        this.backToLocation(tab);
        this.isLoading = false;
      }, (error => {
        this.tabModalInfo = this.tabModals[0];
        this.isShowTabModal = true;
        this.isLoading = false;
      }));
  }

  private fetchGroupTab(): void {
    this.orderApiService.getGroupTabById(this.routeService.getGroupTabId())
      .pipe(filter(Boolean))
      .subscribe((tab: GroupOrderTab) => {
        this.cartStore.groupTab = tab;
        if (this.cacheTab) {
          this.storageService.set(STORAGE_TAB_DATA, new TabInStorage(this.cartStore.groupTab.group_order_id, null, true));
        }
        this.backToGroup(tab);
        this.isLoading = false;
      }, (error => {
        this.tabModalInfo = this.tabModals[0];
        this.isShowTabModal = true;
        this.isLoading = false;
      }));
  }

  private backToLocation(tab: OrderTab): void {
    const merchantId = tab.merchant_id;
    const locationId = tab.location_id;
    const locationUrl = `${this.routeService.getKyooTechPage()}/merchants/${merchantId}`;
    this.router.navigate([locationUrl, 'locations', locationId])
      .catch(error => console.log(error));
  }

  private backToGroup(tab: GroupOrderTab): void {
    const groupUrl = `${this.routeService.createGroupUrl(tab.group_id)}`;
    this.router.navigate([groupUrl])
      .catch(error => console.log(error));
  }

  private backToHomePage(): void {
    const homePageUrl = this.routeService.getKyooTechPage();
    this.router.navigate([homePageUrl])
      .catch(error => console.log(error));
  }
}
